module.exports = __webpack_public_path__ + "static/media/Icon-oil.e0f5a0c2.svg";